import * as React from "react";
import { useCallback, useMemo } from "react";
import styled from "styled-components";
import FieldType from "views/logic/fieldtypes/FieldType";
import CustomHighlighting from "views/components/highlighting/CustomHighlighting";
import ValueActions from "./actions/ValueActions";
import TypeSpecificValue from "./TypeSpecificValue";
import InteractiveContext from "./contexts/InteractiveContext";
const ValueActionTitle = styled.span`
  white-space: nowrap;
`;
const TypeSpecificValueWithHighlight = ({
  field,
  value = void 0,
  type = void 0,
  render = void 0,
  unit = void 0
}) => /* @__PURE__ */ React.createElement(CustomHighlighting, { field, value }, /* @__PURE__ */ React.createElement(TypeSpecificValue, { field, value, type, render, unit }));
const defaultRenderer = ({ value }) => value;
const InteractiveValue = ({
  field,
  value,
  render = defaultRenderer,
  type = FieldType.Unknown,
  unit = void 0
}) => {
  const RenderComponent = useMemo(
    () => render != null ? render : (props) => props.value,
    [render]
  );
  const Component = useCallback(
    ({ value: componentValue }) => /* @__PURE__ */ React.createElement(RenderComponent, { field, value: componentValue }),
    [RenderComponent, field]
  );
  const element = /* @__PURE__ */ React.createElement(TypeSpecificValueWithHighlight, { field, value, type, render: Component, unit });
  return /* @__PURE__ */ React.createElement(ValueActions, { element, field, type, value }, /* @__PURE__ */ React.createElement(ValueActionTitle, { "data-testid": "value-actions-title" }, field, " = ", /* @__PURE__ */ React.createElement(TypeSpecificValue, { field, value, type, truncate: true })));
};
const Value = ({ field, value, render = defaultRenderer, type = void 0, unit = void 0 }) => {
  const _type = type != null ? type : FieldType.Unknown;
  return /* @__PURE__ */ React.createElement(InteractiveContext.Consumer, null, (interactive) => interactive ? /* @__PURE__ */ React.createElement(InteractiveValue, { field, value, render, type: _type, unit }) : /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(TypeSpecificValueWithHighlight, { field, value, render, type: _type, unit })));
};
export default Value;
